/* eslint-disable no-nested-ternary */
import React from 'react';
// Moment library size is very high 100kb zipped and minified

import format from 'date-fns/format';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _get from 'lodash.get';
import Cookie from 'utils/cookies';
import makeRequest from 'utils/makeRequest';
import Link from 'components/Link';
import { loadGeoLocationData } from 'reduxUtils/modules/geo';
import {
  getSectionName,
  getGa4PageViewSet,
  collectEventfireGa4,
  cityNameMap,
} from 'utils/common';
import {
  CITY_LIST_DATA_URL,
  IMAGE_URL,
  REVIEWS_LIVE_DOMAIN,
  TOI_EPAPER_URL_WEB,
  TOI_LIVE_DOMAIN,
} from 'constants/index';
import Login from 'components/Login';
//import ErrorBoundary from 'components/ErrorBoundary';
// import WithGeo from 'helpers/ads/WithGeo';
// import WithTimesPoint from 'modules/WithTimesPoint/WithLazyLoadTimesPoint';
// import WithTimesPointModal from 'modules/WithTimesPointModal';
import WithNotificationCenter from 'modules/WithNotificationCenter';
import WithWeather from 'modules/WithWeather';
import {
  newPlanpageMetaData,
  redirectToNewPlanpage,
  sendDataToGAWithGRX,
} from 'components/ToiSubscription/utils/redirectionToPlanPage';
import { gaWrapper } from 'helpers/analytics';
import EditionSwitch from 'components_v2/common/EditonSwitch';
// import PollutionWidget from 'components_v2/desktop/PollutionWidget/PollutionWidget';
import analyticsWrapper from 'helpers/analytics/analyticsWrapper';
import {
  checkGracePeriod,
  checkPreExpireDate,
  setPayloadInfo,
  checkIsSaleLive,
  getPrcCookieValue,
  getEncTicket,
} from 'utils/primeUtil';
import { sendGaThroughProps } from 'helpers/analytics/sendGaThroughProps';
import InViewObserver from 'components/InViewObserver/InViewObserver';
import Search from '../Search';
import s from './TopBar.scss';
import WithSocials from '../Socials/WithSocials';
import CityModal from '../../../../routes/home/components/desktop/CityModal/CityModalLoader';

class TopBar extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // aqiData: null,
      shouldshowModal: false,
      showCityModalPopupMessage: false,
      isSaleLive: false,
      shouldShowLogin: false,
    };
    this.cityModalPopupMessage = '';
  }

  capitalizeString = string => {
    const words = string.split(' ');
    return words
      .map(word => word[0].toUpperCase() + word.substring(1))
      .join(' ');
  };

  fireGA4 = obj => {
    const gaPageViewObj = getGa4PageViewSet() || {};
    const collatedGadata = {
      ...gaPageViewObj,
      event: 'select_item',
    };
    return collectEventfireGa4(collatedGadata, {
      item_name:
        window.location.href.indexOf('.cms') > -1
          ? document.title
          : window.location.href,
      item_id: this.props.msid || '',
      item_brand: 'product_interventions',
      item_category: 'Nudges',
      item_category2: 'header',
      item_category3: obj?.item_category3 ? obj?.item_category3 : 'N/A',
      item_category4: obj?.item_category4 ? obj?.item_category4 : 'N/A',
      location_id: obj?.location_id ? obj?.location_id : 'N/A',
    });
  };

  // loadAQIData = city => {
  //   // city = 'Ranchi';
  //   makeRequest.get(
  //     `${getSiteDomain()}/pollutiondata.cms?city=${city}&feedtype=sjson`,
  //     {},
  //     'skipfeedengine',
  //   );
  //   // .then(data => {
  //   //   if (data && data.data && data.data.aqi && data.data.airquality) {
  //   //     this.setState({ aqiData: data.data });
  //   //   } else {
  //   //     this.setState({
  //   //       aqiData: null,
  //   //     });
  //   //   }
  //   // });
  // };

  componentDidMount() {
    if (typeof checkIsSaleLive === 'function') {
      this.setState({ isSaleLive: checkIsSaleLive() });
    }
  }

  componentDidUpdate(prevProps) {
    // if (
    //   this.props.city &&
    //   this.props.city !== prevProps.city &&
    //   !this.props.toipLayout
    // )
    if (prevProps.userPrcData !== this.props.userPrcData) {
      checkGracePeriod(this.props.userPrcData).then(res => {
        this.setState({ inGracePeriod: res });
      });
      checkPreExpireDate(this.props.userPrcData).then(res => {
        this.setState({ isPreExpired: res });
      });
    }
  }

  curDate = new Date();
  redirection = () => {
    const prc = getPrcCookieValue();
    const { layoutType, storyTitle, msid } = this.props;
    const getUnifiedNodes = this.props.unifiedNodes[`prc${prc || 0}`];
    if (layoutType === 'primeshow') {
      setPayloadInfo('Header-NewTOIPlusCTA-Click', 'STORY', storyTitle, msid);
    } else {
      setPayloadInfo('Header-NewTOIPlusCTA-Click', 'NON_STORY');
    }

    if (Cookie.get('ssoid') || Cookie.get('ssoId')) {
      getEncTicket(false).then(data => {
        window.location.href = redirectToNewPlanpage(
          newPlanpageMetaData(
            { unifiedNodes: getUnifiedNodes, acqSubSource: 'header_Subscribe' },
            data,
          ),
        );
      });
    } else {
      window.location.href = redirectToNewPlanpage(
        newPlanpageMetaData({
          unifiedNodes: getUnifiedNodes,
          acqSubSource: 'header_Subscribe',
        }),
      );
    }
  };
  handleSubscribeNowCTA = e => {
    e.preventDefault();

    // const prc = getPrcCookieValue();
    // const getUnifiedNodes = this.props.unifiedNodes[`prc${prc || 0}`];
    const { layoutType, storyTitle, msid } = this.props;
    gaWrapper(
      'send',
      'event',
      window.categoryForGA,
      `NavBar-Header`,
      'Header-NewTOIPlusCTA-Click',
    );
    if (layoutType === 'primeshow') {
      setPayloadInfo('Header-NewTOIPlusCTA-Click', 'STORY', storyTitle, msid);
    } else {
      setPayloadInfo('Header-NewTOIPlusCTA-Click', 'NON_STORY');
    }
    const grxParams = [
      'paywall',
      {
        client_source: 'cdp',
        event_nature: 'click',
        event_category: 'subscription',
        cta_text: 'topbanner_cta_text',
        // event_section: 'topbar_subscribe',
        // event_subsection: '',
        // landing_l1: 'plan_page',
        // landing_l2: '',
        // landing_l3: '',
        // landing_page_template: 'plan_page',
        // landing_url: redirectToNewPlanpage(
        //   newPlanpageMetaData({
        //     unifiedNodes: getUnifiedNodes,
        //   }),
        // ),
        // position: 1,
        unique_subscription_id: `${Cookie.get('_grx')}_${new Date().getTime()}`,
      },
    ];
    let cdpInfo = {};
    if (
      typeof window.grx !== 'undefined' &&
      typeof window?.grx_module?.hitPaywallEventReact === 'function'
    ) {
      window.grx_module.hitPaywallEventReact(...grxParams);
      cdpInfo = window.grx_module.getCdpInfo() || {};
    } else {
      window.Times.setGRXDataInLocalStorage('GRX_QUEUE_EVENT', {
        eventName: grxParams[0],
        payload: grxParams[1],
      });
    }
    const cdpParamsObj = grxParams[1] || {};
    const dataToBepassed = {
      source: this.props.userPrcData?.source,
      accessType: this.props.userPrcData?.accessType,
      analytics_cdp: {
        eventName: grxParams[0],
        ...cdpParamsObj,
        ...cdpInfo,
      },
      objUserData: {
        email:
          typeof this.props.userData?.getEmail !== 'undefined'
            ? this.props.userData.getEmail()
            : '',
        fname:
          typeof this.props.userData?.getFirstName !== 'undefined'
            ? this.props.userData.getFirstName()
            : '',
      },
      ga4Items: this.fireGA4({
        item_category4: e.target.innerText || '',
        item_category3: 'header_Subscribe',
      }),
    };
    sendDataToGAWithGRX(dataToBepassed)
      .then(this.redirection)
      .catch(this.redirection);
  };

  updateGeoLocation = (geoCity, setInCookie, geoCityApiName = '') => {
    if (!geoCity) {
      return;
    }
    makeRequest
      .get(
        `https://ematrix.filmipop.com/v2/city/get?city_name=${geoCityApiName ||
          geoCity}`,
        {},
        'skipfeedengine',
      )
      .then(data => {
        if (data && data.data) {
          if (setInCookie) {
            let domain = 'indiatimes.com';
            if (document.domain.indexOf('timesofindia.com') >= 0) {
              domain = 'timesofindia.com';
            }
            Cookie.set('geolocation', geoCity, 365, '/', domain);
            Cookie.set('geostate', data.data.state_code, 365, '/', domain);
            if (typeof this.props.loadGeoLocationData === 'function') {
              this.props.loadGeoLocationData();
            }
            this.setCityModalPopupMessage(
              `Your location has been changed to ${cityNameMap[geoCity] ||
                geoCity}`,
            );
          }
        }
      });
  };

  onCityChange = params => {
    const { clickedItem: { name }, confirmMakingDefCity } = params;
    if (confirmMakingDefCity && name) {
      this.updateGeoLocation(name, true);
      sendGaThroughProps({
        data: {
          gaCategory: 'locationChange',
          gaAction: 'manuallySelect',
          gaLabel: window?.location?.href,
        },
      });
    }
  };

  toggleModal = source => {
    this.setState(
      {
        shouldshowModal: !this.state.shouldshowModal,
      },
      () => {
        if (this.state.shouldshowModal) {
          sendGaThroughProps({
            data: {
              gaCategory: 'locationChange',
              gaAction: 'open',
              gaLabel: window?.location?.href,
            },
          });
        }
      },
    );
    if (source === 'cancel') {
      sendGaThroughProps({
        data: {
          gaCategory: 'locationChange',
          gaAction: 'Cancel',
          gaLabel: window?.location?.href,
        },
      });
    }
  };

  closeCityModal = () => {
    this.setState({
      shouldshowModal: false,
    });
  };

  showLoginModal = value => {
    this.setState({
      shouldShowLogin: value,
    });
  };

  isPromoShowArticle = () =>
    !!this.props.articleSectionData?.[this.props.msid]?.ispromoarticle;

  setCityModalPopupMessage = (message, skipTimer = false) => {
    if (message && typeof message === 'string') {
      this.cityModalPopupMessage = message;
      this.setState({
        showCityModalPopupMessage: true,
      });
      if (!skipTimer) {
        setTimeout(() => {
          this.setState({
            showCityModalPopupMessage: false,
          });
        }, 7000);
      }
    }
  };

  // onSubscribeInviewCallback = () => {
  //   const prc = getPrcCookieValue();
  //   const getUnifiedNodes = this.props.unifiedNodes[`prc${prc || 0}`];
  //   const grxParams = [
  //     'paywall',
  //     {
  //       client_source: 'cdp',
  //       event_nature: 'click',
  //       eventcategory: 'subscription',
  //       ctaTxt:
  //         this.state.inGracePeriod || this.state.isPreExpired
  //           ? 'RENEW NOW'
  //           : 'SUBSCRIBE TO TOI+',
  //       event_section: 'topbar_subscribe',
  //       event_subsection: '',
  //       landing_l1: 'plan_page',
  //       landing_l2: '',
  //       landing_l3: '',
  //       landing_page_template: 'plan_page',
  //       landing_url: redirectToNewPlanpage(
  //         newPlanpageMetaData({
  //           unifiedNodes: getUnifiedNodes,
  //         }),
  //       ),
  //       position: 1,
  //     },
  //   ];
  //   if (typeof window?.grx_module?.hitPaywallEventReact === 'function') {
  //     window.grx_module.hitPaywallEventReact(...grxParams);
  //   } else {
  //     window.Times.setGRXDataInLocalStorage('GRX_QUEUE_EVENT', {
  //       eventName: grxParams[0],
  //       payload: grxParams[1],
  //     });
  //   }
  // };

  render() {
    const {
      hideTimeStamp,
      colorTheme,
      isPrime,
      showToiPlusEntryPoints,
      pageType,
      toipLayout,
      isAffiliatePage,
      enableCityChangeFeature,
      isTechnology,
      isPrimeUserLayout,
    } = this.props;

    const theme = colorTheme ? s[colorTheme] : '';
    let dateString;

    if (!hideTimeStamp) {
      dateString = format(
        this.curDate,
        'ddd, MMM DD, YYYY | [Updated] hh.mmA [IST]',
      );
    }

    const getSiteTopLogoLink = () => {
      let logoMsid = isTechnology ? '109343604' : '92222747';
      let ariaLabel = 'Times of India';
      let url = isTechnology
        ? `${TOI_LIVE_DOMAIN}/technology`
        : this.props.TOILogoUrl;
      if (this.props.isReviewsPage) {
        url = REVIEWS_LIVE_DOMAIN;
        logoMsid = '113492625';
        ariaLabel = 'Times Reviews';
      }
      return (
        <Link
          to={url}
          aria-label={ariaLabel}
          ga4Data={[
            {
              event: 'user_click',
              type: 'header',
              label: 'toi_logo',
            },
          ]}
        >
          <img
            src={`${IMAGE_URL}${logoMsid}.cms`}
            alt="TOI logo"
            width="300"
            height={isTechnology ? '45' : '24'}
          />
        </Link>
      );
    };

    const getButtonText = () => {
      if (this.state.isSaleLive) {
        return 'TOI+ WINTER SALE';
      } else if (this.state.inGracePeriod || this.state.isPreExpired) {
        return 'RENEW NOW';
      }
      return 'SUBSCRIBE TO TOI+';
    };
    const sectionName = getSectionName(
      this.props.articleSectionData,
      this.props.newsData,
      this.props.msid,
      this.props.liveblogData,
    );

    const {
      shouldshowModal,
      showCityModalPopupMessage,
      shouldShowLogin,
    } = this.state;

    return (
      <div
        id="top-bar-container"
        className={`${s['top-area']} ${theme} top-area ${
          pageType === 'ARTICLESHOW' ? `as_topBar` : ''
        } ${isTechnology ? s.gadgetNow : ''} ${
          toipLayout ? s.toip_ad_layer : ''
        }
        ${this.props.isReviewsPage ? s.reviewLogo : ''}
        ${isPrimeUserLayout ? s.primelayout : ''}
       ${
         (this.isPromoShowArticle() || isPrimeUserLayout) &&
         (shouldshowModal || shouldShowLogin)
           ? s.modalPrimelayout
           : ''
       }
        
 `}
      >
        <div className="contentwrapper">
          <div className={`${s.row} ${toipLayout ? s.toipRow : ''} rel`}>
            {toipLayout && (
              <div
                className={`${s.column} ${!toipLayout ? s.toicolumn : ''} ${
                  s.logoWrapper
                }`}
                onClick={() => {
                  analyticsWrapper(
                    'ga',
                    'send',
                    'event',
                    'WEB-Prime-AS',
                    'NavBar-TOI_back',
                    'Section_View',
                  );
                }}
              >
                <Link
                  className={s.toiLogo}
                  to={this.props.TOILogoUrl}
                  title="The Times of India"
                  aria-label="toi-home"
                >
                  toi
                </Link>
              </div>
            )}
            <div className={`${s.column} ${!toipLayout ? s.toicolumn : ''}`}>
              {toipLayout && (
                // eslint-disable-next-line jsx-a11y/anchor-has-content
                <a
                  href="/toi-plus"
                  className={s.toipLogo}
                  aria-label="toi-plus"
                  onClick={() => {
                    analyticsWrapper(
                      'ga',
                      'send',
                      'event',
                      'WEB-Prime-AS',
                      'NavBar-Logo',
                      'Section_View',
                    );
                  }}
                />
              )}
              {this.props.editionSwitch &&
                !toipLayout && (
                  <div className={s.leftColChild}>
                    <EditionSwitch
                      editionSwitch={this.props.editionSwitch}
                      colorTheme={colorTheme}
                    />
                  </div>
                )}
              {dateString &&
                !toipLayout && (
                  <div className={`${s['date-time']} ${s.leftColChild}`}>
                    {dateString}
                  </div>
                )}
              {enableCityChangeFeature &&
                this.props.city && (
                  <div className={s.cityName} onClick={this.toggleModal}>
                    <span>
                      <em className={s.locationIcon} />
                    </span>
                  </div>
                )}
              {shouldshowModal && (
                <CityModal
                  dataUrl={CITY_LIST_DATA_URL}
                  onChangeCallback={this.onCityChange}
                  geoCityData={{ city: this.props.city }}
                  toggleModal={this.toggleModal}
                  closeCityModal={this.closeCityModal}
                  updateGeoLocation={this.updateGeoLocation}
                  setCityModalPopupMessage={this.setCityModalPopupMessage}
                  enableCityChangeAcross
                  enableUserLocationDetection
                />
              )}
              {showCityModalPopupMessage &&
                this.cityModalPopupMessage && (
                  <div className={s.modalPopup}>
                    <span>{this.cityModalPopupMessage}</span>
                    <button
                      onClick={() => {
                        this.setState({
                          showCityModalPopupMessage: false,
                        });
                      }}
                    >
                      <em className={s.crossIcon} />
                    </button>
                  </div>
                )}
              {!toipLayout && (
                <div className={s.leftColChild}>
                  <WithWeather
                    isWapView={this.props.isWapView}
                    isWeatherInC={this.props.showWeatherInC}
                    colorTheme={colorTheme}
                    gaCategory="weather_top_nav_cta"
                  />
                </div>
              )}
            </div>

            {pageType === 'ARTICLESHOW' && (
              <div className={s.toi_logo_top}>{getSiteTopLogoLink()}</div>
            )}

            {/* {this.props.msid === '109191097' && (
              <div className={`${s.toi_logo_top} ${s.gadget_by_toi}`}>
                <Link to={this.props.TOILogoUrl} aria-label="Times of India ">
                  <img
                    src="https://static.toiimg.com/photo/109343604.cms"
                    alt="Gadget Now by Times of India "
                    width="232"
                    height="45"
                  />
                </Link>
              </div>
            )} */}

            {!this.props.isReviewsPage && (
              <div className={`${s.column} ${!toipLayout ? s.toicolumn : ''}`}>
                {/* {pageType !== 'ARTICLESHOW' &&
                  pageType !== 'printeditionhp' &&
                  pageType !== 'printeditionas' && (
                    <InViewObserver
                      ga={{
                        action: 'NavBar-Header',
                        label: 'Header-readEpaperCTA-View',
                        category:
                          typeof window !== 'undefined'
                            ? window.categoryForGA
                            : '',
                      }}
                      className={s.epaperButtonWrapper}
                    >
                      <Link
                        type="button"
                        className={s.epaperButton}
                        to={TOI_EPAPER_URL_WEB}
                        data-ga={`${
                          typeof window !== 'undefined'
                            ? window.categoryForGA
                            : ''
                        }|NavBar-Header|Header-readEpaperCTA-Click`}
                        ga4Data={[
                          {
                            event: 'user_click',
                            type: 'read_epaper',
                            category: 'header',
                          },
                        ]}
                      >
                        Read ePaper
                      </Link>
                    </InViewObserver>
                  )} */}
                {/* {!this.props.disableTimesPointWidget ||
              (this.props.disableTimesPointWidget && isPrime) ? (
                <WithTimesPoint
                  isWapView={false}
                  disableTimesPointWidget={this.props.disableTimesPointWidget}
                />
              ) : null} */}
                <div className={s.toiplusButtonWrapper}>
                  {typeof window !== 'undefined' &&
                    typeof window.geoinfo !== 'undefined' &&
                    (window.geoinfo.CountryCode === 'IN' ||
                      showToiPlusEntryPoints) &&
                    ((!isPrime &&
                      pageType !== 'toiplusplanpage' &&
                      !isAffiliatePage) ||
                      (isPrime &&
                        (this.state.inGracePeriod ||
                          this.state.isPreExpired))) && (
                      <InViewObserver
                        ga={{
                          action: 'NavBar-Header',
                          label: 'Header-NewTOIPlusCTA-View',
                        }}
                        // inViewCallback={() => this.onSubscribeInviewCallback()}
                      >
                        <Link
                          type="button"
                          className={s.toiplusButton}
                          to={redirectToNewPlanpage(newPlanpageMetaData())}
                          onClick={e => {
                            this.handleSubscribeNowCTA(e);
                          }}
                        >
                          {getButtonText()}
                        </Link>
                      </InViewObserver>
                    )}
                </div>
                <Login
                  isMobile={false}
                  query={this.props.query}
                  pageType={pageType}
                  toipLayout={toipLayout}
                  showLoginModal={this.showLoginModal}
                  skipReloadForPrimeLogin={this.props.skipReloadForPrimeLogin}
                />
                <WithNotificationCenter theme="home" colorTheme={colorTheme} />
                {!toipLayout && (
                  <WithSocials
                    colorTheme={colorTheme}
                    sectionName={sectionName}
                  />
                )}
                {/* <ErrorBoundary> */}
                {/* <WithGeo
                  render={({ geoCountry }) =>
                    !this.props.disableTimesPointWidget && (
                      <WithTimesPointModal
                        isWapView={false}
                        disablePrimeFlow={geoCountry !== 'IN'}
                        hideTimesPointPopup={this.props.hideTimesPointPopup}
                        noBaseCss={false}
                        disableTimesPointWidget={
                          this.props.disableTimesPointWidget
                        }
                      />
                    )
                  }
                /> */}
                {/* </ErrorBoundary> */}
              </div>
            )}
          </div>
          {toipLayout && (
            <>
              <Search
                theme={colorTheme}
                isWapView={this.props.isWapView}
                // sticky={stickyHeader}
                highlightSearchedWordInResult
                toipLayout={toipLayout}
              />
            </>
          )}
        </div>
      </div>
    );
  }
}

TopBar.propTypes = {
  hideTimeStamp: PropTypes.bool,
  query: PropTypes.shape({}),
  isWapView: PropTypes.bool,
  editionSwitch: PropTypes.shape({}),
  // hideTimesPointPopup: PropTypes.bool,
  colorTheme: PropTypes.string,
  showWeatherInC: PropTypes.bool,
  pageType: PropTypes.string,
  showToiPlusEntryPoints: PropTypes.bool,
  // disableTimesPointWidget: PropTypes.bool,
  // showPollutionInfo: PropTypes.bool,
  city: PropTypes.string,
  TOILogoUrl: PropTypes.string,
  isAffiliatePage: PropTypes.bool,
  enableCityChangeFeature: PropTypes.bool,
  layoutType: PropTypes.string,
  storyTitle: PropTypes.string,
  msid: PropTypes.string,
  toipLayout: PropTypes.bool,
  isTechnology: PropTypes.bool,
  isPrimeUserLayout: PropTypes.bool,
};
TopBar.defaultProps = {
  hideTimeStamp: false,
  query: {},
  isWapView: false,
  editionSwitch: undefined,
  // hideTimesPointPopup: false,
  colorTheme: '',
  showWeatherInC: false,
  pageType: '',
  showToiPlusEntryPoints: false,
  // disableTimesPointWidget: false,
  // showPollutionInfo: true,
  city: undefined,
  TOILogoUrl: '/',
  isAffiliatePage: false,
  enableCityChangeFeature: false,
  layoutType: '',
  storyTitle: '',
  msid: '',
  toipLayout: false,
  isTechnology: false,
  isPrimeUserLayout: false,
};

const mapDispatchtoProps = dispatch => ({
  loadGeoLocationData: params => {
    dispatch(loadGeoLocationData(params));
  },
});

const mapStateToProps = state => ({
  city: _get(state, 'geo.cityData.city'),
  userPrcData: state.login.userPrcData,
  unifiedNodes: _get(state, 'translationConfig.nudges.unifiedNodes', {}),
});

export default connect(mapStateToProps, mapDispatchtoProps)(TopBar);
